import { AudioBar, Box } from "@aircall/tractor";
import { AssetsColors } from "@/constants/style.constants";
import { useTrackPlaying } from "@/hooks/useTrackPlaying/useTrackPlaying";
import { PlayerCurrentTime } from "../PlayerCurrentTime/PlayerCurrentTime";
import { PlayerDuration } from "../PlayerDuration/PlayerDuration";
import { AudioBarGrid } from "./PlayerAudioBar.styled";

export function PlayerSimpleAudioBar({ color }: { color: AssetsColors }) {
  const handleOnClick = useTrackPlaying("audio_bar");

  return (
    <AudioBarGrid data-test="simple-audio-bar">
      <PlayerCurrentTime />
      <Box onClick={handleOnClick}>
        <AudioBar color={color} />
      </Box>
      <PlayerDuration />
    </AudioBarGrid>
  );
}
